import { useCallback, useEffect, useRef, useState } from "react";

const usePointerLock = () => {
  const [forceShowCursor, setForceShowCursor] = useState(false);
  useEffect(() => {
    const onPointerLockChange = () => {
      if (!!document.pointerLockElement) {
        setForceShowCursor(false);
      } else {
        setForceShowCursor(true);
      }
    };
    document.addEventListener("pointerlockchange", onPointerLockChange);
    return () => {
      document.removeEventListener("pointerlockchange", onPointerLockChange);
    };
  }, []);

  return {
    forceShowCursor,
  };
};
export default usePointerLock;
